import { z } from 'zod';

import {
  type APITriplet,
  type ModelTriplet,
  RDK_MODEL_NAME_BUILTIN,
} from '$lib/resource-type';

import { isBuiltinAPI } from './api-types';
import { isBuiltinModel } from './models';
import { ServiceSubtypes } from './services';

export const isBuiltinDataManagementService = (
  api: APITriplet,
  model: ModelTriplet
) =>
  isBuiltinAPI(api, ServiceSubtypes.DATA_MANAGER) &&
  isBuiltinModel(model, RDK_MODEL_NAME_BUILTIN);

export const DataManagementAttributesSchema = z
  .object({
    sync_interval_mins: z.number().optional(),
    capture_dir: z.string().optional(),
    tags: z.array(z.string()).optional(),
    additional_sync_paths: z.array(z.string()).optional(),
    capture_disabled: z.boolean().optional(),
    sync_disabled: z.boolean().optional(),
  })
  .passthrough();

export type DataManagementAttributes = z.infer<
  typeof DataManagementAttributesSchema
>;
